import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoDelete = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 15,
			cy: 15,
			r: 15,
			fill: "#EB5757"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5356 18.5352L11.4646 11.4641",
			stroke: "white",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4644 18.5352L18.5354 11.4641",
			stroke: "white",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgLogoDelete;
